import { render, staticRenderFns } from "./ModalCostumers.vue?vue&type=template&id=450658bf&scoped=true"
import script from "./ModalCostumers.vue?vue&type=script&lang=js"
export * from "./ModalCostumers.vue?vue&type=script&lang=js"
import style0 from "./ModalCostumers.vue?vue&type=style&index=0&id=450658bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450658bf",
  null
  
)

export default component.exports